import React from 'react';

export const AppStoreButton = ({ className = "download-btn" }) => {
    return (
        <a href="https://apps.apple.com/app/nibblet/id6754262721" className={className}>
            <img src="/apple_store_download.svg" alt="Download on the App Store" className="download-btn-image" />
        </a>
    );
};

export const GooglePlayButton = ({ className = "download-btn" }) => {
    return (
        <a href="https://play.google.com/store/apps/details?id=com.nibblet.app&hl=en_US" className={className}>
            <img src="/google_play_store_download.svg" alt="Get it on Google Play" className="download-btn-image" />
        </a>
    );
};
